import { combineReducers } from 'redux';
import { takeLatest } from 'redux-saga/effects';

import articlePicturesReducer, {
  getPicturesSaga,
} from '@/domains/productDiscovery/ArticleReviews/ArticlePictures.ducks';
import reviewCardVotingReducer from '@/domains/productDiscovery/ArticleReviews/components/ReviewCardVoting/reviewCardVoting.ducks';
import mainReviewsReducer, {
  getMainReviewsSaga,
} from '@/domains/productDiscovery/ArticleReviews/MainReviews.ducks';
import mdScoresReducer, {
  getMdScoresSaga,
} from '@/domains/productDiscovery/ArticleReviews/MdScores.ducks';
import reviewStatsReducer, {
  getReviewsStatsSaga,
} from '@/domains/productDiscovery/ArticleReviews/ReviewsStats.ducks';

export const GET_REVIEWS_STATS_TRIGGER = 'product/GET_REVIEWS_STATS_TRIGGER';

export function* rootReviewsStatsSaga() {
  yield takeLatest(GET_REVIEWS_STATS_TRIGGER, getReviewsStatsSaga);
  yield takeLatest(GET_REVIEWS_STATS_TRIGGER, getMainReviewsSaga);
  yield takeLatest(GET_REVIEWS_STATS_TRIGGER, getMdScoresSaga);
  yield takeLatest(GET_REVIEWS_STATS_TRIGGER, getPicturesSaga);
}

export const articleReviewsReducer = combineReducers({
  mdScores: mdScoresReducer,
  reviewsStats: reviewStatsReducer,
  articlePictures: articlePicturesReducer,
  mainReviews: mainReviewsReducer,
  votes: reviewCardVotingReducer,
});
